import { createSimpleMaterializer } from '@wix/materializer'
import { BeckyModel } from '@wix/thunderbolt-becky-root'
import { RefSchemas, MetricsReporter } from '@wix/thunderbolt-becky-types'
import {
	CatharsisConstants,
	MaterializerFactorySymbol,
	CatharsisSingleTransactionSymbol,
	css as catharsisIocLoader,
} from '@wix/thunderbolt-catharsis-ioc'
import { Container } from '@wix/thunderbolt-ioc'
import { AsyncNodes, AsyncStores } from './types'

export const getInvalidationResults = (
	asyncNodes: AsyncNodes,
	beckyModel: BeckyModel,
	schemas: RefSchemas,
	metricsReporter: MetricsReporter
) => {
	const container = Container()
	const catharsisConstants: CatharsisConstants = {
		componentsMappers: beckyModel.componentsMappers,
		experiments: beckyModel.experiments,
		isEditor: false,
		isExperimentOpen: (exp) => !!beckyModel.experiments[exp],
		schemas,
		isResponsiveMasterPage: beckyModel.isResponsive && beckyModel.pageCompId === 'masterPage',
	}
	container.load((bind) => catharsisIocLoader(bind, catharsisConstants))
	container.bind(MaterializerFactorySymbol).toConstantValue(createSimpleMaterializer)

	const invalidationResults = asyncNodes.map((node) => node.addInvalidation(container))
	const singleTransaction = container.get(CatharsisSingleTransactionSymbol)
	singleTransaction.execute(beckyModel, metricsReporter.runAndReport)

	return invalidationResults.map((x) => [...x])
}

export const runAsyncAfterInvalidationFuncs = async (
	asyncNodes: AsyncNodes,
	invalidationResults: Array<Iterable<any>>
) => {
	const storesArr = await Promise.all(
		asyncNodes.map((node, index) => {
			return node.afterInvalidation(invalidationResults[index])
		})
	)

	const storesMap: Partial<AsyncStores> = storesArr.reduce((acc, store, index) => {
		return { ...acc, [asyncNodes[index].name]: store }
	}, {})
	return storesMap
}

export const getAsyncStore = async (
	asyncNodes: AsyncNodes,
	beckyModel: BeckyModel,
	metricsReporter: MetricsReporter,
	schemas: RefSchemas
): Promise<Partial<AsyncStores>> => {
	const invalidationResults = getInvalidationResults(asyncNodes, beckyModel, schemas, metricsReporter)

	return await runAsyncAfterInvalidationFuncs(asyncNodes, invalidationResults)
}
